import { render, staticRenderFns } from "./AdminShopOrdersReport.vue?vue&type=template&id=78762280&scoped=true"
import script from "./AdminShopOrdersReport.vue?vue&type=script&lang=js"
export * from "./AdminShopOrdersReport.vue?vue&type=script&lang=js"
import style0 from "./AdminShopOrdersReport.vue?vue&type=style&index=0&id=78762280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78762280",
  null
  
)

export default component.exports